import { render, staticRenderFns } from "./collarDetailsInfo.vue?vue&type=template&id=0aa764a4"
import script from "./collarDetailsInfo.vue?vue&type=script&lang=js"
export * from "./collarDetailsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports